import React from 'react';
import {
  PiHockeyLight,
  PiTennisBallLight,
  PiSoccerBallLight,
  PiBasketballLight,
  PiVolleyballLight,
  PiBaseballLight,
  PiRacquetLight,
  PiPersonSimpleSkiLight,
  PiBoxingGloveLight,
  PiBowlingBallLight,
  PiGameControllerLight,
  PiPersonSimpleThrowLight,
  PiFootballLight,
  PiGolfLight,
  PiBicycleLight,
  PiCricketLight,
  PiPersonSimpleBikeLight,
  PiPersonSimpleSwimLight,
  PiSnowflakeLight,
  PiMotorcycleLight,
} from 'react-icons/pi';
import { FC, SVGProps } from 'react';

type IconComponent = FC<SVGProps<SVGSVGElement> & { size?: number | string }>;

export const SPORT_ICON_MAP: Record<string, IconComponent> = {
  PiHockeyLight,
  PiTennisBallLight,
  PiSoccerBallLight,
  PiBasketballLight,
  PiVolleyballLight,
  PiBaseballLight,
  PiRacquetLight,
  PiPersonSimpleSkiLight,
  PiBoxingGloveLight,
  PiBowlingBallLight,
  PiGameControllerLight,
  PiPersonSimpleThrowLight,
  PiFootballLight,
  PiGolfLight,
  PiBicycleLight,
  PiCricketLight,
  PiPersonSimpleBikeLight,
  PiPersonSimpleSwimLight,
  PiSnowflakeLight,
  PiMotorcycleLight,
};

interface SportIconProps {
  name?: string | null;
  size?: number;
}

export const SportIcon: React.FC<SportIconProps> = ({ name, size = 18 }) => {
  if (!name) return null;
  const Icon = SPORT_ICON_MAP[name];
  if (!Icon) return null;
  return <Icon size={size} aria-hidden />;
};
